import request from "@/utils/request";
import store from "@/store";

// 新的接口, 获取医院的基本数据
export function getHospitalInfo() {
  return request({
    url: "/srs/hospital-data",
    method: "get",
    params: { token: store.state.userInfo.token }
  });
}

// 病例表(急救车的查询)
export function getPatient(id) {
  return request({
    url: "/medicalhistory/api",
    method: "get",
    params: { id }
  });
}

// 新的接口病例表
export function getPatientsInfo(form) {
  return request({
    url: "/srs/medicalhistory-data",
    method: "get",
    params: {
      page: form.page,
      number: form.number2,
      numbers: form.pageSize,
      car: form.carName, // 急救车id 1, 2, 3...
      start: form.start, // 开始时间, 格式: 2022-12-30
      end: form.end, // 结束时间, 格式: 2022-12-30
      addr: form.addr, // 急救地址
      name: form.medicalhistoryName, // 患者姓名
      gender: form.gender, // 性别: 男/女
      mainComplaint: form.mainComplaint // 主诉
    }
  });
}

// export function searchdPatient(data) {
//   return request({
//     url: "/medicalhistory/api",
//     method: "post",
//     data
//   });
// }

export function changePatient(data) {
  return request({
    url: "/medicalhistory/api",
    method: "put",
    data
  });
}

// 急救车添加新的病例 (保存修改的信息)
export function addPatient(data) {
  return request({
    url: "/medicalhistory/api",
    method: "put",
    data
  });
}

export function searchdPatient(data) {
  return request({
    url: "/medicalhistory/api",
    method: "post",
    data
  });
}

/**
 * 提交急救车得事例编辑
 * */
export function editAmbulancePatientInfo(id, data, method = "POST") {
  return request({
    url: "/new/version/medical/incident/info",
    method: method,
    headers: { "Content-Type": "application/json" },
    transformRequest: null,
    params: {
      medicalhistoryId: id,
      ambulance_type: "急救车"
    },
    data
  });
}

/**
 * 提交无人机/车事例编辑
 * */
export function editSmartPatientInfo(id, data, method = "POST", object) {
  return request({
    url: "/new/version/medical/incident/info",
    method: method,
    headers: { "Content-Type": "application/json" },
    transformRequest: null,
    params: {
      medicalhistoryId: id,
      ambulance_type: object
    },
    data
  });
}
